import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';

declare function loadAVI(): any;

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  static readonly events$ = new BehaviorSubject<{
    type?: 'login attempt' | 'logout' | 'login success' | 'login response' | 'login change'
  }>({});

  constructor(
    private readonly router: Router,
    private readonly auth: AuthService
  ) {}

  checkCredentials() {
    const idEmpresaLogada = localStorage.idEmpresaLogada;
    return !!idEmpresaLogada;
  }

  getIdCliente() {
    return localStorage.getItem('idCliente');
  }

  logout() {
    sessionStorage.setItem('logoff', 'true');
    sessionStorage.removeItem('usuarioLogado');
    LoginService.events$.next({type: 'logout'});
    Cookie.delete('access_token');
    localStorage.clear();
    console.clear();
    this.auth.signOut().catch(() => this.router.navigate(['/portal']));
  }
}
